$(document).on("click", ".expand-value", function(){
  $(this).prev().text($(this).data("full-value"));
  $(this).text("Less");
  $(this).toggleClass("collapse-value expand-value");
  
});
$(document).on("click", ".collapse-value", function(){
  $(this).prev().text($(this).data("truncated-value"));
  $(this).text("More");
  $(this).toggleClass("collapse-value expand-value");
});